// Display labels for participant.bahai_status.
//
// Storage values are 'yes' / 'no' / 'unknown' — those stay unchanged and are
// what the database, RPC validation (migration 31's _normalize_sensitive_value),
// and value-conflict detection consume. These labels are display-only.
export const BAHAI_STATUS_LABELS = {
  yes: "Bahá'í",
  no: "Friend of the Faith",
  unknown: "Unknown",
}

// Resolve a stored value to its display label. Unknown / null / unrecognized →
// fallback ('Unknown' by default; pass '' for CSV cells).
export const bahaiStatusLabel = (value, fallback = 'Unknown') =>
  BAHAI_STATUS_LABELS[value] ?? fallback
